<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M313 967 l-283 -282 0 -44 c0 -36 6 -49 34 -77 24 -24 43 -34 65 -34
l31 0 0 -195 c0 -220 7 -251 62 -285 29 -17 50 -20 174 -20 101 0 144 4 151
13 7 8 0 50 -23 132 l-32 120 -1 -97 -1 -98 -110 0 c-158 0 -150 -14 -150 253
l0 212 205 205 205 205 120 -120 c116 -116 121 -119 161 -118 23 1 44 4 46 7
10 10 -308 316 -327 316 -12 0 -109 -89 -252 -230 -127 -126 -239 -230 -248
-230 -20 0 -40 19 -40 40 0 20 520 540 540 540 21 0 540 -521 540 -542 0 -9
-5 -20 -10 -23 -13 -8 -13 -72 0 -80 6 -4 26 9 45 28 29 29 35 42 35 77 0 40
-5 48 -85 129 l-85 87 0 192 c0 223 12 205 -130 200 l-85 -3 -3 -77 c-2 -43
-6 -78 -9 -78 -4 0 -44 36 -89 80 -77 75 -84 80 -125 80 l-44 0 -282 -283z
m697 86 l0 -127 -40 39 -40 39 0 88 0 88 40 0 40 0 0 -127z"
      />
      <path
        d="M950 690 c-8 -5 -32 -10 -53 -10 -21 0 -52 -6 -70 -14 -37 -15 -86
-69 -88 -94 -1 -10 -4 -7 -8 7 -3 13 -18 33 -33 44 -23 17 -29 18 -54 6 -38
-18 -47 -81 -15 -101 15 -9 21 -23 21 -50 0 -20 -4 -40 -10 -43 -5 -3 -10 -15
-10 -26 0 -13 -7 -19 -24 -19 -48 0 -51 -18 -32 -183 10 -84 22 -160 27 -169
9 -16 31 -18 250 -18 l239 0 17 35 17 36 18 -35 c20 -40 48 -40 48 0 0 13 9
46 20 74 36 92 21 128 -50 116 -42 -7 -109 5 -167 29 l-35 15 31 35 c17 20 31
40 31 46 0 6 26 -12 57 -40 84 -75 102 -67 62 25 -16 35 -23 78 -28 167 -7
119 -8 120 -39 148 -34 30 -91 39 -122 19z m90 -30 c27 -14 40 -64 40 -149 0
-42 4 -92 10 -110 12 -42 10 -45 -19 -25 -16 12 -20 19 -12 27 14 14 14 54 1
62 -5 3 -10 26 -10 51 0 49 -16 89 -49 118 -12 11 -21 23 -21 28 0 11 37 10
60 -2z m-105 -20 c26 -10 75 -56 75 -71 0 -5 -16 3 -36 16 -62 42 -147 31
-191 -25 -7 -8 -13 -10 -13 -4 0 20 42 66 74 80 38 16 57 17 91 4z m-242 -52
c7 -21 -4 -38 -23 -38 -23 0 -34 16 -26 35 7 18 43 20 49 3z m217 -17 c0 -31
-99 -105 -117 -88 -11 12 20 68 46 82 30 16 71 20 71 6z m-191 -111 c-7 -16
-17 -26 -21 -24 -15 9 -8 77 10 97 17 19 17 19 20 -12 2 -18 -2 -45 -9 -61z
m262 68 c11 -21 11 -22 -4 -9 -10 7 -17 17 -17 22 0 15 9 10 21 -13z m11 -58
c17 0 4 -65 -13 -68 -12 -2 -15 3 -12 21 6 29 -20 43 -37 21 -10 -11 -10 -17
0 -29 11 -13 5 -15 -41 -14 -30 0 -48 3 -41 6 15 6 16 43 0 43 -6 0 8 14 30
30 23 17 42 35 42 42 0 6 14 -3 31 -20 17 -18 36 -32 41 -32z m-175 -45 c10
-22 9 -25 -8 -25 -14 0 -19 7 -19 25 0 32 12 32 27 0z m-57 -52 c0 -7 13 -27
30 -46 32 -37 26 -57 -18 -57 -13 0 -32 -5 -43 -10 -17 -10 -19 -7 -19 24 0
21 6 36 15 40 8 3 15 14 15 24 0 11 -7 25 -15 32 -23 19 -18 29 10 17 14 -7
25 -17 25 -24z m197 -30 c-38 -38 -96 -38 -134 0 l-28 27 95 0 95 0 -28 -27z
m-324 10 c-23 -4 -34 -43 -13 -43 6 0 10 -13 10 -30 0 -49 -27 -37 -34 15 -9
54 -3 65 32 64 24 -2 24 -2 5 -6z m34 -85 c-2 -13 -4 -5 -4 17 -1 22 1 32 4
23 2 -10 2 -28 0 -40z m263 4 c0 -5 -9 -17 -20 -27 -19 -17 -21 -17 -40 0 -29
27 -25 35 20 35 22 0 40 -4 40 -8z m-86 -48 c13 -19 15 -29 7 -37 -14 -14 -27
-1 -36 36 -9 34 4 34 29 1z m121 -13 c-7 -31 -28 -41 -40 -20 -7 10 34 63 43
55 2 -3 1 -18 -3 -35z m-181 -4 c3 -18 13 -43 22 -55 15 -22 17 -22 40 -8 13
9 26 16 29 16 3 0 5 -22 5 -50 l0 -50 -124 0 c-69 0 -127 3 -129 8 -3 4 -8 37
-12 75 -7 66 -6 67 18 67 19 0 27 -9 40 -41 14 -34 14 -41 1 -46 -26 -10 -16
-35 14 -31 26 3 27 6 30 60 2 46 7 61 25 73 30 21 34 19 41 -18z m236 -9 c1
-18 9 -51 20 -73 22 -45 25 -65 10 -65 -5 0 -10 11 -10 25 0 16 -6 25 -15 25
-9 0 -15 -9 -15 -25 0 -23 -3 -25 -50 -25 l-50 0 0 50 0 50 26 -17 c25 -16 27
-16 40 2 8 10 17 33 20 52 8 42 24 43 24 1z m109 -6 c14 -8 26 -11 28 -6 8 24
22 36 32 29 14 -8 1 -57 -25 -103 -1 -2 -11 2 -23 10 -16 10 -23 10 -33 0 -6
-6 -15 -12 -19 -12 -12 0 -42 87 -34 100 8 12 38 5 74 -18z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
